import React from 'react';
import FAQSectionV2 from '@zola/zola-ui/src/components/PreAuth/FAQSectionV2';
import FAQSectionItem from '@zola/zola-ui/src/components/PreAuth/FAQSectionItem';

import containerStyles from '~/styles/landingPageShared.module.less';

import FAQCopy from './FAQCopy';

const FAQ: React.FC = () => (
  <div className={containerStyles.sectionContainer}>
    <FAQSectionV2
      title="All Your Cash Gift Questions, Answered"
      maxHeight="375px"
      maxExpandedHeight="3000px"
      expandedByDefault
    >
      {FAQCopy.map((q, i) => (
        <FAQSectionItem key={i} title={q.question} description={q.answer} />
      ))}
    </FAQSectionV2>
  </div>
);

export default FAQ;
